import React from 'react'
import { Link } from 'react-router-dom'

function ShowEventButton({item}) {
    return (
      <>  <Link to={"/event/" + item._id}>
      <a>Détails</a>
            </Link> 
            </>
        
    )
}

export default ShowEventButton
